<template>
  <div
    class="pies-wrap mt-0 mb-0 graphs-wrap pointer-events-none d-flex flex-wrap align-items-start"
    :data-key="uuid"
    :class="{ 'pies-aligned': piesAligned }"
  >

    <div class="d-flex flex-wrap pies-pair" v-for="pair in data.pairs">
      <pie-title :data="data" :bot-held="botHeld" :text="pair.title" v-if="pair.title"/>

      <div class="w-100 d-flex align-items-start" :style="{ height: isSmall ? vwScale(data.height) : data.deskHeight + 'px' }">
        <component
          v-for="(pie, idx) in pair.points"
          :key="idx"
          :target="pie.val[industry]"
          :label="{ title: pie.title, pos: 'bottom', align: 'center' }"
          :active="active"
          :stroke="pie.color === 'accent' ? [ accent, mainColor ] : [ mainColor, accent ]"
          :class="[ idx === 1 && !piesAligned ? 'align-self-end' : '' ]"
          :percent-size="pie.fontSize"
          :ind-override="indOverride"
          :it-target="pie.val.it"
          :mktg-target="pie.val.mktg"
          :is="data.style === 'fill' ? 'PieFillFragment' : 'PieFragment'"
          @activated.once="activated = true"
        />
      </div>
    </div>

  </div>
</template>

<script>
  import GraphMixin from '@/components/report/mixins/GraphMixin'
  import ContentMixin from '@/components/report/mixins/ContentMixin'
  import PieFragment from '@/components/report/content/PieFragment'
  import PieFillFragment from '@/components/report/content/PieFillFragment'
  import PieTitle from '@/components/report/content/PieTitle'

  export default {
    name: 'Pie',
    mixins: [ ContentMixin, GraphMixin ],
    props: { botHeld: Boolean },
    data () {
      return {
        piesAligned: this.data.align.match( /(?:center|start|top)/i )
      }
    },
    components: { PieFragment, PieFillFragment, PieTitle }
  }
</script>

<style lang="scss">
  @import "../../../assets/scss/global/the_goods";

  .pie-content-wrap {

    .graph-copy {
      @include screen-md-lg-xl {
        min-height : 120px;
      }
    }

    .pies-wrap {
      margin-top : viewport-scale(30);

      @include screen-desktop {
        width     : 100%;
        max-width : 780px;
        margin    : rem(10) auto rem(20) auto;
      }

      .pies-pair {
        width : 100%;
      }

      &.pies-aligned {

        @include screen-md-lg-xl {
          max-width       : 820px;
          justify-content : space-between;

          .percentage-wrap {
            .percent {
              margin-bottom : 0.1em;
            }
            .percent-num {
              font-size : rem(72);
            }
            .percent-sign {
              font-size : rem(36);
            }
            .percent-label {
              font-size : rem(20);
            }
          }
        }

        .pie-wrap {
          &:first-child {
            margin : 0 rem(10) 0 0;
          }
          &:last-child {
            margin : 0 0 0 rem(10);
          }
        }

        .pies-pair {
          @include screen-md-lg-xl {
            width : 46%;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/report/content/Pie.vue